// Geyser flood-target-site helpers. Pure. No React, no Three.js.
//
// ── Codex (Geyser, Flooded, Airborne) ──
//   • "This turn, flood target site and give each minion there
//     Airborne." The target is a SITE the caster picks; the runtime
//     restricts the target halo to in-play Site cards via the standard
//     filter ({ type: 'Site' }).
//   • Flooded grants the site a minimum of 1 W (so the site becomes a
//     water site); applied via the `flooded` status toggle, same as
//     Avatar of Water / Waveshaper.
//   • Airborne is granted to every Minion sharing the site's cell.
//
// The runtime owns the status writes + broadcast + recompute; these
// helpers just locate the minions stacked on the picked site so the
// orchestrator can grant the keyword through the unified
// toggleCardStatus primitive.

import { countsAsMinion } from '../../../core/typeline';

/**
 * Every Minion whose mesh resolves to the same cell as the picked
 * site. Avatars and Sites are excluded ("each minion there"); the
 * site card itself is structurally separate from the units atop it.
 *
 * @param meshes  host.meshes Map
 * @param cellAt  (x, z) => { col, row } | null
 * @param col / row the picked site's cell
 * @returns cardInstance[] of minions standing on the site
 */
export function minionsAtCell(meshes, cellAt, col, row) {
  const out = [];
  for (const [, mesh] of meshes) {
    const card = mesh?.userData?.cardInstance;
    if (!card || !countsAsMinion(card)) continue;
    const cell = cellAt(mesh.position.x, mesh.position.z);
    if (!cell || cell.col !== col || cell.row !== row) continue;
    out.push(card);
  }
  return out;
}
